// import external dependencies

import "jquery";
import "slick-carousel";

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/_mapsvg-map-story.js";
import "./modules/mega-menu";
import "./modules/slick-slider";
import"./modules/sidebar";
import ForeFreedomMegaMenu from "./modules/mega-menu";
import CategoryAjaxDropdown from "./modules/category-ajax-dropdown";

jQuery(document).ready(() => {
	new ForeFreedomMegaMenu(
		".nav-primary",
		".menu-item-has-children",
		".dropdown-menu"
	);

	const categoryDropdown = $("#cat");
	const postsContainer = $(".ajax-container");

	if (categoryDropdown.length && postsContainer.length) {
		new CategoryAjaxDropdown(categoryDropdown, postsContainer, true);
	}

	const header = document.querySelector("header");
	const navbar = document.querySelector("#primaryNavBar");
	const toggler = document.querySelector(".navbar-toggler");

	window.addEventListener("scroll", function() {
		if (window.pageYOffset > 0) {
			header.classList.add("scrolled");
		} else if (window.pageYOffset === 0 && !toggler.classList.contains("collapsed")) {
			header.classList.add("scrolled");
		} else {
			header.classList.remove("scrolled");
		}
	});

	toggler.addEventListener("click", function() {
		if (!navbar.classList.contains("show")) {
			header.classList.add("scrolled");

		} else {
			header.classList.remove("scrolled");
		}
	});
});



// WEBPACK FOOTER //
// ./scripts/main.js